import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import Header from "./Header";
import Footer from "./Footer";
import Governance from "./Governance";

export const GovernancePage = () => {
  const navigate = useNavigate();

  useEffect(() => {
    window.scrollTo({ top: 0 });
  }, []);

  return (
    <div
      data-testid="ablemp-governance-page"
      className="min-h-screen bg-[#0A0F14]"
    >
      <Header />

      {/* Page hero */}
      <section
        data-testid="governance-page-hero"
        className="relative bg-[#0A0F14] text-white pt-32 md:pt-40 pb-10 md:pb-16"
      >
        <div className="absolute inset-0 bg-grain-dark opacity-50 pointer-events-none" />
        <div className="relative max-w-[1400px] mx-auto px-6 md:px-10">
          <button
            data-testid="back-to-home"
            onClick={() => navigate("/")}
            className="inline-flex items-center gap-2 text-[11px] uppercase tracking-[0.3em] text-white/55 hover:text-[#FEDF00] transition-colors"
          >
            <ArrowLeft size={14} />
            Voltar à página inicial
          </button>
          <div className="mt-8 flex items-center gap-4 text-[11px] uppercase tracking-[0.3em] text-white/55">
            <span className="flag-rule" aria-hidden />
            <span>Página institucional · Governança</span>
          </div>
        </div>
      </section>

      <main>
        <Governance />
      </main>

      <Footer />
    </div>
  );
};

export default GovernancePage;
